import { getTimestamp } from '../getters/get-time-stamp';
import { getCookie, setCookie } from '../helpers/cookie';
import { uuidv4 } from '../helpers/uuid';
import { scheduleFirstLaunchEvent } from './schedule-tech-events';
const DEVICE_COOKIE_KEY = '_sv';
const LOCAL_DEVICE_COOKIE_KEY = '_sa';
const COOKIE_PREFIX = 'SA';
const COOKIE_VERSION = '1';
// 30 дней в миллисекундах
const DEVICE_ID_RECHECK_TIMEOUT = 2592000000;
let promiseDeviceId;

/**
 * Инициализация установки deviceId
 * @param {String} deviceIdUrl адрес получения deviceId
 * @param {Request} requestAdapter сетевой адаптер
 * @return {void}
 */
export const setDeviceId = async (deviceIdUrl, requestAdapter) => {
  const firstLaunch = !getCookie(DEVICE_COOKIE_KEY);
  if (firstLaunch) {
    promiseDeviceId = requestAdapter({
      url: deviceIdUrl,
      method: 'GET',
      credentials: true
    }).then(response => {
      if (typeof response?.id === 'string' && !getCookie(DEVICE_COOKIE_KEY)) {
        setCookie(DEVICE_COOKIE_KEY, response.id, DEVICE_ID_RECHECK_TIMEOUT);
      }
      return void 0;
    }).finally(() => {
      const deviceId = getCookie(DEVICE_COOKIE_KEY);
      if (deviceId) {
        scheduleFirstLaunchEvent(deviceId);
      }
    });
  }
};
const setLocalDeviceId = () => {
  const currentCookieValue = getCookie(LOCAL_DEVICE_COOKIE_KEY);
  if (!currentCookieValue) {
    const uuid = uuidv4();
    const cookieValue = `${COOKIE_PREFIX}${COOKIE_VERSION}.${uuid}.${String(getTimestamp())}`;
    setCookie(LOCAL_DEVICE_COOKIE_KEY, cookieValue, DEVICE_ID_RECHECK_TIMEOUT);
    scheduleFirstLaunchEvent(cookieValue);
  }
};

/**
 * Получение ранее запрощенного deviceId, если deviceId не был получен, создаем его локально
 * @return {Promise<String>} deviceId
 */
export const getDeviceId = async () => {
  try {
    await promiseDeviceId;
  } catch (e) {
    /* Если не установили cookie по причине отсутствия url или его неработоспособности */
  }
  const globalDeviceId = getCookie(DEVICE_COOKIE_KEY);
  if (!globalDeviceId) {
    setLocalDeviceId();
    return getCookie(LOCAL_DEVICE_COOKIE_KEY);
  }
  return globalDeviceId;
};